import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { keyframes } from "styled-components";
var TRANSITION_SPEED_MS = "300ms";
var BADGE_SIZE = 20;
var ICON_SIZE = 40;
export var IconWithCountBadge = function(param) {
    var icon = param.icon, count = param.count;
    var hideBadge = count === undefined || count === "0";
    // Add spacing of 7px per digit in count to keep consistent spacing between icon and badge
    var spacerSize = (count === null || count === void 0 ? void 0 : count.length) ? ((count === null || count === void 0 ? void 0 : count.length) - 1) * 7 : 0;
    return /*#__PURE__*/ _jsxs(Row, {
        children: [
            !hideBadge ? /*#__PURE__*/ _jsx(IconCountBadgeWrapper, {
                children: /*#__PURE__*/ _jsx(IconCountBadge, {
                    children: /*#__PURE__*/ _jsx(StyledTypography, {
                        variant: "labelSansMedium",
                        children: count
                    })
                })
            }) : null,
            /*#__PURE__*/ _jsx(IconWrapper, {
                align: "center",
                justify: "center",
                children: icon
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: spacerSize
            })
        ]
    });
};
var IconWrapper = styled(Row).withConfig({
    componentId: "sc-d2af2614-0"
})([
    "&:hover{background-color:",
    ";}height:",
    "px;width:",
    "px;border-radius:50%;transition:all ",
    " ease-out;"
], Core.surface.subdued, ICON_SIZE, ICON_SIZE, TRANSITION_SPEED_MS);
var IconCountBadgeWrapper = styled(Row).withConfig({
    componentId: "sc-d2af2614-1"
})([
    "position:absolute;min-width:",
    "px;height:",
    "px;left:",
    "px;top:0;z-index:1;&:hover + ",
    "{transition:all ",
    " ease-in;background-color:",
    ";padding:",
    ";}"
], BADGE_SIZE, BADGE_SIZE, ICON_SIZE - BADGE_SIZE, IconWrapper, TRANSITION_SPEED_MS, Core.surface.subdued, getSpacing("1x"));
var bounce = keyframes([
    "0%{transform:scale(0);opacity:0;}40%{transform:scale(1);opacity:1;}45%{transform:scale(0.94);opacity:1;}50%,100%{transform:scale(1);opacity:1;}"
]);
var IconCountBadge = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-d2af2614-2"
})([
    "border-radius:",
    "px;background:",
    ";border:2px solid ",
    ";padding:5px;min-width:",
    "px;animation:",
    " 1s ease-in-out;animation-fill-mode:both;"
], BADGE_SIZE * 2, Core.surface.default, Core.text.inverse, BADGE_SIZE, bounce);
var StyledTypography = styled(Typography).withConfig({
    componentId: "sc-d2af2614-3"
})([
    "color:",
    ";"
], Core.text.inverse);
